<div class="page-toolbar">
  <div class="page-toolbar__start">
    <df-button variant="text" icon="heroArrowLeft" (onClick)="back.emit()">{{ 'BACK' | translate }}</df-button>
    <span class="divider"></span>
    <h1 class="page-title">{{ sectionTitle }}</h1>
    @if (hasStatus) {
      <span class="status-pill" [ngClass]="isComplete ? 'completed' : 'in-progress'">
        {{ (isComplete ? 'MISSION.CONFIG_STATUS.COMPLETED' : 'MISSION.CONFIG_STATUS.IN_PROGRESS') | translate }}
      </span>
    }
  </div>
  <div class="page-toolbar__end">
    @if (hasStatus) {
      @if (isComplete) {
        <df-button icon="heroArrowUturnLeft" (onClick)="toggleStatus.emit()">{{ 'REOPEN' | translate }}</df-button>
      } @else {
        <df-button icon="heroCheckCircle" (onClick)="toggleStatus.emit()">{{ 'MARK_COMPLETED' | translate }}</df-button>
      }
    }
    @if (addLabel && !isComplete) {
      <df-button variant="primary" icon="heroPlus" (onClick)="add.emit()">{{ addLabel }}</df-button>
    }
  </div>
</div>
